import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';
import { InquiryTypeStateTag } from '@framework/common-web/ui/inquiry/state/InquiryTypeStateTag.tsx';
import { useCurrentLocale } from '@framework/i18n/hooks/useCurrentLocale.ts';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Card, Divider, Space } from 'antd';
import Title from 'antd/es/typography/Title';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import { getImageUrl } from '../../../inquiries/cover/component/getImageUrl.tsx';

const DossierInquiryListItemCard = styled(Card)`
  .ant-card-body {
    padding: 0;
  }
`;
const DossierInquiryListItemBodyContainer = styled.div`
  padding: 12px;
  padding-left: 24px;
`;

const DossierInquiryListItemImageContainer = styled.div`
  background: ${props => props.theme.colorBorder};
  min-width: 100px;
  width: 20vw;
  max-width: 300px;
  height: 100%;
  aspect-ratio: 1/0.5;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${props => props.theme.borderRadius}px 0 0
    ${props => props.theme.borderRadius}px;

  margin-inline-start: 0;
  margin-inline-end: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  ${down('md')} {
    display: none;
  }
`;
const ListItemButtonRow = styled.div`
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
`;
const ListItemStateRow = styled.div`
  padding-bottom: 12px;
`;
const InquiryListTitle = styled(Title)`
  &&& {
    font-size: ${props => props.theme.fontSizeHeading3}px;
    margin-bottom: 0;
  }
`;

export interface IDossierInquiryListItemProps {
  inquiry?: TipoDomandaDTO;
  actions?: React.ReactNode;
  startDate?: string | null;
  endDate?: string | null;
}

export function DossierInquiryListItem(props: IDossierInquiryListItemProps) {
  const { inquiry, actions, startDate, endDate } = props;
  const { t } = useTranslation();
  const locale = useCurrentLocale();

  if (!inquiry) return null;

  const hasImage = !!inquiry?.copertina?.sfondo;
  const imageUrl = getImageUrl(inquiry?.copertina?.sfondo, locale.tag);

  return (
    <DossierInquiryListItemCard>
      <FlexRow
        align="stretch"
        left={
          <DossierInquiryListItemImageContainer>
            {hasImage ? (
              <img
                alt={t(
                  'domande.lista.elemento.alt-immagine.copertina-domanda',
                  'copertina domanda',
                )}
                src={imageUrl}
              />
            ) : (
              <div />
            )}
          </DossierInquiryListItemImageContainer>
        }
      >
        <DossierInquiryListItemBodyContainer>
          <div key={inquiry.id}>
            <ListItemStateRow>
              <FlexRow right={actions}>
                <div>
                  <InquiryTypeStateTag inquiry={inquiry} />
                  {/* data di inizio se ancora non è iniziata, oppure la data di scadenza */}
                  <Space split={<Divider type="vertical" />} size={0}>
                    {startDate && (
                      <span>
                        {t(
                          'domande-secondarie.lista.elemento.etichetta.avviabile-dal',
                          'Avviabile dal',
                        )}
                        :{' '}
                        <strong>
                          <ISODate date={startDate} />
                        </strong>
                      </span>
                    )}
                    {endDate && (
                      <span>
                        {t(
                          'domande-secondarie.lista.elemento.etichetta.scadenza-invio',
                          'Scadenza invio',
                        )}
                        :{' '}
                        <strong>
                          <ISODate date={endDate} />
                        </strong>
                      </span>
                    )}
                  </Space>
                </div>
              </FlexRow>
              {/* {inquiry.dataFine && (
                <>
                  {t('domande.lista.elemento.etichetta.scadenza', 'Scadenza')}
                  : <ISODate date={inquiry.dataFine} />
                </>
              )} */}
            </ListItemStateRow>
            <InquiryListTitle level={2}>{inquiry.titolo}</InquiryListTitle>
            {/* <ListItemButtonRow>{actions}</ListItemButtonRow> */}
          </div>
        </DossierInquiryListItemBodyContainer>
      </FlexRow>
    </DossierInquiryListItemCard>
  );
}
